import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Form, Button, Card, Space } from "antd";
import { toast } from "react-toastify";
import FormFields from "../AddSamplesPage/FormFields"; // Assurez-vous que le chemin est correct vers votre FormFields commun
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getSampleByID, updateSample } from "../../../redux/slices/samples/samplesThunk";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const EditSamplePage = () => {
  const sample_loading = useSelector((state) => state.samples.updatedSamples.loading); // Correction selecteur loading
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const history = useHistory();
  const { id } = useParams();

  const onFinish = (values) => {
    // On envoie 'values' qui contient { name: "...", sampleCode: "..." }
    dispatch(updateSample({
      id: id,
      samplesData: values, // <-- CORRECTION (était productsData)
    })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Échantillon modifié avec succès!");
        form.resetFields();
        navigateTo("/samples"); // <-- CORRECTION URL
      } else {
        toast.error("Erreur pendant la modification!");
      }
    });
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  const onReset = () => {
    form.resetFields();
  };

  useEffect(() => {
    dispatch(getSampleByID(id)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        form.setFieldsValue({
          name: res.payload?.name,
          sampleCode: res.payload?.sampleCode, // <-- AJOUT : Pré-remplissage du code
        });
      }}
    )
  }
  , [dispatch, id , form]);

  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Modifier un Échantillon" // <-- Titre corrigé
      />
      <Card bordered={false}>
        <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
          <FormFields />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit" 
              loading={sample_loading}
              >
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button
                type="link"
                htmlType="button"
                onClick={() => navigateTo("/samples")}
              >
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default EditSamplePage;